import { AxiosResponse } from "axios";
import { _get, _aiTraceAsError, _post, _postFormData } from "./BaseApiService";

// Endpoints
const PROMOTION_TEMPLATE = "Promotion";
const PROMOTION_TEMPLATE_GRID = "GetPromotionTemplates";
const GET_PROMOTION_TEMPLATE_BY_ID = "GetPromotionTemplate";
const ADD_EDIT_PROMOTION_TEMPLATE = "AddEditPromotionTemplate";

export interface promotionTemplatesGridRowItem {
    id: number;
    businessEntityId: number;
    businessEntity: string;
    brandId:number;
    brandName:string;
    serviceTypeId: number;
    serviceType: string;
    serviceSubTypeId: number;
    serviceSubType: string;
    typeLookUpId: number;
    typeLookUp: string;
    link: string;
    linkTypeId: number;
    linkType: string;
    active: string;
    description: string;
}

export default class promotionTemplatesService {
    getPromotionTemplateGridData(): Promise<AxiosResponse<any>> {
        return _get(`${PROMOTION_TEMPLATE}/${PROMOTION_TEMPLATE_GRID}`);
    }
    addEditPromotionTemplate(formData: FormData): Promise<AxiosResponse<any>> {
        return _postFormData(`${PROMOTION_TEMPLATE}/${ADD_EDIT_PROMOTION_TEMPLATE}`, formData);
    }
    getPromotionTemplateById(id:string): Promise<AxiosResponse<any>> {
        return _get(`${PROMOTION_TEMPLATE}/${GET_PROMOTION_TEMPLATE_BY_ID}/${id}`);
    }
}
